import { range } from 'lodash';
import { Instance, types as t } from 'mobx-state-tree';
import { SentenceCompleteAnswerQuestions } from '../../../question-data-model/Question/_implementations/sentence-complete-question.store';
import { AbstractDoTestQuestionWithBlanks } from './abstract-do-test-question-with-blanks.store';

export const DoTestSentenceCompleteQuestion = t
  .compose(AbstractDoTestQuestionWithBlanks, SentenceCompleteAnswerQuestions)
  .named('DoTestSentenceCompleteQuestion')
  .actions((self) => ({
    setSentence(sentence) {
      const { id, value } = sentence;
      const existedSentence = self.sentences.find((ua) => ua.id === id);
      existedSentence.editorValue = value;
    },
  }))
  .views((self) => ({
    get groupName() {
      return 'Sentence Complete';
    },

    get formattedQuestionNo() {
      return self.no;
    },

    get bottomBarQuestionNoes() {
      const blankCount = self.sentences.reduce((p, n) => p + n.blanks.length, 0);
      return range(blankCount)
        .map((noIndex) => {
          const no = self.no + noIndex;
          return {
            no,
            answered: self.isAnswered(
              self.userAnswers.find((_u, userAnswerIndex) => userAnswerIndex === noIndex)
            ),
          };
        })
        .filter((item) => Boolean(item));
    },

    get questionCount() {
      return self.sentences.reduce((p, n) => p + n.blanks.length, 0);
    },

    get answerCount() {
      return (self?.userAnswers || []).filter((o) => self.isAnswered(o)).length;
    },

    prepareDataForSubmit() {
      return {
        sentences: self.sentences,
        questionId: self.uuid,
        type: self.type as any,
        userAnswers: self.userAnswers,
      };
    },
  }));

export interface DoTestSentenceCompleteQuestionInstance
  extends Instance<typeof DoTestSentenceCompleteQuestion> {}
